import { useMutation } from "@tanstack/react-query";
import { WiMuleSQL } from "../../services/WiMuleSQL";

export const useGetUserDetails = () => {
  return useMutation({
    mutationFn: async ({ email, wiToolName }) => {
      try {
        // Construct query parameters based on available data
        const queryParams = new URLSearchParams();
        if (email) queryParams.append("email", email);
        if (wiToolName) queryParams.append("wiToolName", wiToolName);

        const response = await fetch(
          `${WiMuleSQL}/api/Auth/GetUserAccountData?${queryParams.toString()}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response.status === 404) {
          return { userExists: false, data: null };
        }
        if (!response.ok) {
          throw new Error(`HTTP Error: ${response.status}`);
        } else {
          const data = await response.json();
          return { userExists: true, data };
        }
      } catch (error) {
        throw new Error(error.message);
      }
    },
  });
};
